export default "__VITE_ASSET__CjaFujuE__"